import Layout from '@/components/feature/Layout';
import { useSEO } from '@/hooks/useSEO';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestUpdates from './components/LatestUpdates';
import HotPicks from './components/HotPicks';
import SiteIntro from './components/SiteIntro';

export default function HomePage() {
  useSEO({
    title: '年轻的岳母 - 高清电视剧与电影在线观看平台',
    description:
      '年轻的岳母网站提供丰富的电视剧与电影资源，涵盖各种题材和热门剧集，用户可便捷浏览、了解剧情和演员信息，享受优质影视内容体验。',
    keywords: '年轻的岳母,电视剧,电影,影视资源,在线影视,剧情介绍,影视下载,影视大全',
  });

  return (
    <Layout>
      <HeroCarousel />
      <CategoryEntries />
      <LatestUpdates />
      <HotPicks />
      <SiteIntro />
    </Layout>
  );
}